import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, effect, input, output } from '@angular/core';
import { ReportInfo, ReportRecord } from '../../../models/report.model';
import deepmerge from 'deepmerge';

import { MatIcon } from '@angular/material/icon';
import { L10nTranslationModule } from 'angular-l10n';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rep-data-view-toolbar',
  templateUrl: './data-view-toolbar.component.html',
  styleUrl: './data-view-toolbar.component.scss',
  imports: [MatIcon, L10nTranslationModule],
})
export class DataViewToolbarComponent implements OnInit, OnDestroy {
  draggedRowIndex: number;
  reportRecordData: ReportRecord[];

  readonly reportData = input.required<ReportInfo>();
  readonly isUKFeaturesEnabled = input<boolean>(false);

  readonly customizeColumns = output<string>();
  readonly reportReordered = output<ReportRecord[]>();

  constructor() {
    effect(() => {
      const reportData = this.reportData();
      this.reportRecordData = deepmerge([], reportData ? reportData.records : null);
    });
  }

  ngOnInit(): void {
    // required by angular-l10n
  }

  ngOnDestroy(): void {
    // required by angular-l10n
  }
}
